import { Component, OnInit, Input } from '@angular/core';
import { BreadcrumbProgressControl } from './breadcrumb-progress.control';

@Component({
  selector: 'breadcrumb-progress',
  templateUrl: './breadcrumb-progress.component.html',
  styleUrls: ['./breadcrumb-progress.component.scss']
})
export class BreadcrumbProgressComponent implements OnInit {
  @Input() entity: BreadcrumbProgressControl;

  constructor() {}

  ngOnInit(): void {}

  getClasses(index: number) {
    let cssClass = index <= this.entity.progressIndex ? 'active' : '';
    if (index === 0) {
      cssClass += ' first-element';
    } else if (this.entity.titles.length - 1 === index) {
      cssClass += ' last-element';
    }
    return cssClass;
  }
}
